import { LoginForm } from "components/login-form/login-form";
import { FC, useState } from "react";
import { LoginPageProps } from "./types";
import { LoadingSpinner } from "components";

export const LoginPage: FC<LoginPageProps> = ({ checkTypedPwd }) => {
  const [submittedPassword, setSubmittedPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmitAction = (pwd: string) => {
    setLoading(true);
    setSubmittedPassword(pwd);
    checkTypedPwd(pwd);
    setLoading(false);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <LoginForm
      title="Area ad accesso riservato"
      inputPlaceholder="Password"
      inputType="password"
      initialInputValue={submittedPassword}
      submitAction={handleSubmitAction}
    />
  );
};
